// import ApiSetting from './api/setting.js'
import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const audioApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/audios/`,
      {params: params})
  },
  detail (audioId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/audios/${audioId}/`,
      {params: params})
  }
}

export default audioApi
